import { FC } from 'react';

import shieldImg from 'assets/brand/shield@2x.png';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';

import locales from './locales';
import { Props } from './types';

const BlockDeviceSuccess: FC<Props> = ({ close }) => (
  <SunshineModal isOpen onClose={close}>
    <SunshineModal.Header />

    <SunshineModal.Body>
      <SunshineModal.Body.Image src={shieldImg} />
      <Heading marginBottom="space-16">{locales.title}</Heading>
      <Text marginBottom="space-16">{locales.description}</Text>
    </SunshineModal.Body>

    <SunshineModal.Footer>
      <Button icon="arrow-right" onClick={close}>
        {locales.backToDeviceList}
      </Button>
    </SunshineModal.Footer>
  </SunshineModal>
);

export default BlockDeviceSuccess;
